const api = '/api/v1'
const development = process.env.NODE_ENV === 'development'

const contextPath = development ? '/portal' : ''
const uploadUrl = `${contextPath}${api}/system/file/upload`

module.exports = {
  name: '辰山植物园',
  prefix: 'csnbg',
  title: '辰山植物园',
  footerText: 'Copyright © 2022.辰山植物园 All rights reserved.',
  openPages: ['/login', '/', '/group-apply', '/ticket', '/ticket/guide'],
  apiPrefix: api,
  api: {
    userLogin: `/login/sms`,
    userLogout: `/logout`,
    currentInfo: `/current`,
  },
  contextPath,
  uploadUrl,
}
